/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";


export default class SocialMediaContainer extends DbBaseObject{

	linkedInUrl: string = null
	youtubeUrl: string = null
	twitterUrl: string = null
	facebookUrl: string = null
	instagramUrl: string = null


	constructor(name: string = null) {
		super();
		this.name = name;
	}
}
